<template>
  <div class="price-histogram-slider">
    <div class="slider-wrapper">
      <!-- 1) Statická linka (track) -->
      <div class="track"></div>

      <!-- 2) Histogram bars -->
      <div class="bars">
        <div
            v-for="bar in completeBars"
            :key="bar.rangeFrom"
            class="bar"
            :style="barStyle(bar)"
        ></div>
      </div>

      <!-- 3) Zvýrazněný úsek mezi thumby -->
      <div class="selected-track" :style="selectedTrackStyle"></div>

      <!-- 4) Thumby -->
      <input
          class="thumb thumb--lower"
          type="range"
          :min="min"
          :max="max"
          :step="step"
          v-model.number="local[0]"
          @input="updateRange('lower')"
          @change="onChange"
      />
      <input
          class="thumb thumb--upper"
          type="range"
          :min="min"
          :max="max"
          :step="step"
          v-model.number="local[1]"
          @input="updateRange('upper')"
          @change="onChange"
      />
    </div>

    <!-- 5) Popisky pod sliderem -->
    <div class="labels">
      <div class="thumb-label">{{ formatMoney(local[0]) }}</div>
      <div class="thumb-label">{{ formatMoney(local[1]) }}</div>
    </div>
  </div>
</template>

<script setup>
import { usePriceHistogramSlider } from '@/composables/usePriceHistogramSlider'

const props = defineProps({
  modelValue: { type: Array,  required: true }, // [from, to]
  min:        { type: Number, required: true },
  max:        { type: Number, required: true },
  bars:       { type: Array,  required: true }, // [{ rangeFrom, rangeTo, count }]
  step:       { type: Number, required: true },  // musíš předat z rodiče!
})
const emit = defineEmits(['update:modelValue'])

// Use the composable for shared logic
const {
  local,
  updateRange,
  onChange,
  barStyle: baseBarStyle,
  selectedTrackStyle,
  formatMoney,
  completeBars
} = usePriceHistogramSlider(props, emit)

// --- 6) Styl každého bar
function barStyle(bar) {
  return baseBarStyle(bar, '#fff', '#1a1a1a')
}
</script>

<style scoped>
.price-histogram-slider { width: 100%; }
.slider-wrapper { position: relative; height: calc(100px + 12px); }
.track {
    position: absolute; top:100px; left:0;
    width:100%; height:4px;
    background:#1a1a1a; border-radius:2px; z-index:1;
}
.bars {
    position:absolute; top:0; left:10px; right:10px;
    height:100px; z-index:2;
    overflow: hidden;
}
.bar {
    position:absolute; bottom:0;
    border-radius:2px;
}
.selected-track {
    position:absolute; top:100px; height:4px;
    background:#1EF1C6; border-radius:2px; z-index:2;
}
.thumb {
    -webkit-appearance:none; position:absolute;
    top:88px; left:0; width:100%;
    background:transparent; pointer-events:none;
    /* Firefox-specific fixes */
    -moz-appearance: none;
}
.thumb::-webkit-slider-thumb {
    -webkit-appearance:none; pointer-events:auto;
    width:24px; height:24px;
    background:#1EF1C6; border:4px solid #000;
    border-radius:50%; cursor:pointer;
}
.thumb::-moz-range-thumb {
    width:24px; height:24px;
    background:#1EF1C6; border:4px solid #000;
    border-radius:50%; cursor:pointer;
    pointer-events:auto;
    /* Firefox-specific fixes */
    -moz-appearance: none;
    box-sizing: border-box;
}
.thumb::-moz-range-track {
    background: transparent;
    border: none;
    height: 4px;
    -moz-appearance: none;
}
.thumb::-moz-focus-outer {
    border: 0;
}
.thumb--lower { z-index:3; }
.thumb--upper { z-index:4; }
.labels {
    display:flex; justify-content:space-between;
    margin-top:0.5rem;
    margin-bottom:4rem;
    width: 100%;
    pointer-events: none;
}
.thumb-label {
    background: #1EF1C6;
    color: #000;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 0.5rem;
    white-space: nowrap;
    min-width: 30px;
    text-align: center;
    z-index: 6;
}
</style>
